;(function(win) {

  if (win._qblog) return;

  var utils = require('./helper/utils');
  var es = require('./helper/es');
  var wsd = require('./api.wsd');
  var tcss = require('./api.tcss');

  var __wsd = wsd({autopv: false, autoPerformance: false, isCustom: false});

  var qblog = {

    setting: function (confs, opts) {
      if (es.isObject(confs)) confs = [confs];

      es.each(confs, function (conf, idx) {
        var _conf = es.extend({}, wsd.default_conf, conf);
        var p = 'p' + _conf.protocol, k = 'k' + _conf.key;

        if (qblog[p] && qblog[k]) return;

        var w = wsd(_conf);
        // 第一个设置为默认
        if (idx === 0) qblog.wsd = w;
        // 快捷方式访问
        // qblog.p8888.k520.click('a.b.c')
        // qblog.k520.click('a.b.c')
        if (!qblog[p]) qblog[p] = {};
        qblog[p][k] = qblog[k] = w;
      });

      // 自动性能 performance.timing
      if (qblog.wsd && qblog.wsd.conf.autoPerformance) {
        qblog.wsd.performance();
      }
    },

    tcss: tcss,

    // -------------------------------------------------------------------------
    // 快捷访问的 API，便于老项目的逐步迁移

    fs: function (time, pname) {
      __wsd.fs(time, pname);
    },

    performance: function (pname) {
      __wsd.performance(pname);
    },

    track: function (opts, fn1, fn2) {
      opts.isCustom = true;
      __wsd.track(opts, fn1, fn2);
    }
  };

  win._qblog = qblog;

})(window);


//////////////////
// WEBPACK FOOTER
// ./src/index.web.js
// module id = 7
// module chunks = 0